export const colors = {
  lightGray: '#f2f2f5',
  midGray: '#c7c7cc',
  darkGray: 'rgba(0, 0, 0, 0.54)',
  gray: '#e0e0e0',
  darkBlue: '#000042',
  midBlue: '#00008f',
  lightRed: '#F08682',
  midRed: '#FE0004',
};

export const fontSizes = {
  tableContent: '12px',
  fieldContent: '14px',
  small: '16px',
  medium: '20px',
  large: '24px',
};

export const lineupLegendColors = {
  sameName: '#8FABF8 !important',
  goalkeeper: '#AEFEB1 !important',
};

export const positionCategoryColors = {
  GOALKEEPER: '#FFC107', // Amber
  DEFENDER: '#4CAF50', // Green
  MIDFIELDER: '#2196F3', // Blue
  FORWARD: '#F44336', // Red
};

export const positionCategoryTextColors = {
  GOALKEEPER: '#000000', // Black for contrast on amber
  DEFENDER: '#FFFFFF', // White for contrast on green
  MIDFIELDER: '#FFFFFF', // White for contrast on blue
  FORWARD: '#FFFFFF', // White for contrast on red
};
